
import React, { useState, useEffect } from 'react';
import { Menu, X, Terminal } from 'lucide-react';

const navItems = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'FAQ', href: '#faq' },
];

interface NavbarProps {
  onContactClick: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ onContactClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleContact = (e: React.MouseEvent) => {
    e.preventDefault();
    onContactClick();
    setIsOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-slate-950/90 backdrop-blur-md border-b border-slate-800 py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2 text-mc-blue font-bold text-xl tracking-tight">
            <Terminal className="w-8 h-8 text-mc-blue" />
            <span className="font-mono text-white">Zivush<span className="text-mc-blue">Development</span></span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a 
                key={item.label} 
                href={item.href}
                className="text-sm font-medium text-slate-300 hover:text-mc-blue transition-colors"
              >
                {item.label}
              </a>
            ))}
            <button 
              onClick={handleContact}
              className="px-4 py-2 bg-mc-blue text-slate-950 font-bold rounded text-sm hover:bg-mc-darkblue transition-colors cursor-pointer"
            >
              Contact / Hire Me
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => {
                setIsOpen(!isOpen);
              }} 
              className="text-slate-300 hover:text-white"
            >
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-slate-900 border-b border-slate-800">
          <div className="flex flex-col p-4 gap-4">
            {navItems.map((item) => (
              <a 
                key={item.label}
                href={item.href}
                onClick={() => {
                  setIsOpen(false);
                }}
                className="text-slate-300 hover:text-mc-blue font-medium"
              >
                {item.label}
              </a>
            ))}
            <button 
              onClick={handleContact}
              className="text-left text-mc-blue font-bold font-medium"
            >
              Contact Me (Discord)
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};
